module.exports = __webpack_public_path__ + "img/smile.1e40f4d6.svg";